// Snapshots share unchanged notes and image data; cap retained board states.
export const createHistory = (limit = 100) => {
  let past = [];
  let future = [];
  let previousGroup;
  let previousTime = 0;
  return {
    record(current, group, time = Date.now()) {
      if (!group || group !== previousGroup || time - previousTime > 750) {
        past.push(current);
        if (past.length > limit) past.shift();
      }
      previousGroup = group;
      previousTime = time;
      future = [];
    },
    undo(current) {
      previousGroup = undefined;
      if (!past.length) return current;
      future.push(current);
      return past.pop();
    },
    redo(current) {
      previousGroup = undefined;
      if (!future.length) return current;
      past.push(current);
      return future.pop();
    }
  };
};
